/**
 * Adaptis Quick Buy Drawer
 * Логіка: відкриття drawer, завантаження варіантів, додавання в кошик
 */

(function () {
  'use strict';

  // ─── DOM refs ───────────────────────────────────────────────────────────────
  const overlay    = document.getElementById('quick-buy-overlay');
  const drawer     = document.getElementById('quick-buy-drawer');
  const closeBtn   = document.getElementById('qb-close-btn');
  const loading    = document.getElementById('qb-loading');
  const content    = document.getElementById('qb-content');
  const optionsEl  = document.getElementById('qb-options');
  const variantInp = document.getElementById('qb-variant-id');
  const submitBtn  = document.getElementById('qb-submit-btn');
  const unavailMsg = document.getElementById('qb-unavailable');
  const titleEl    = document.getElementById('qb-product-title');
  const priceEl    = document.getElementById('qb-product-price');
  const imageEl    = document.getElementById('qb-product-image');

  if (!drawer) return; // snippet not loaded

  // ─── State ──────────────────────────────────────────────────────────────────
  let productData     = null;
  let selectedOptions = [];
  let parentProductId = null;

  // ─── Helpers ────────────────────────────────────────────────────────────────

  function formatMoney(cents) {
  const amount = cents / 100;
  const locale = document.documentElement.lang || 'en';
  const currency = window.Shopify?.currency?.active || 'USD';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

  function findVariant() {
    if (!productData) return null;
    return productData.variants.find(v =>
      v.options.every((opt, i) => opt === selectedOptions[i])
    ) || null;
  }

  function showLoading() {
    loading.removeAttribute('aria-hidden');
    content.setAttribute('aria-hidden', 'true');
    loading.style.display = 'flex';
    content.style.display = 'none';
  }

  function showContent() {
    loading.setAttribute('aria-hidden', 'true');
    content.removeAttribute('aria-hidden');
    loading.style.display = 'none';
    content.style.display = 'block';
  }

  // ─── Open / Close ────────────────────────────────────────────────────────────

  function openDrawer() {
    drawer.removeAttribute('aria-hidden');
    overlay.removeAttribute('aria-hidden');
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    // Focus close button for accessibility
    setTimeout(() => closeBtn.focus(), 300);
  }

  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    productData = null;
  }

  overlay.addEventListener('click', closeDrawer);
  closeBtn.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  // ─── Load product data ───────────────────────────────────────────────────────

  async function loadProduct(handle) {
   let rootPath = '/';
  if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
    rootPath = window.Shopify.routes.root;
  } else if (window.Shopify && window.Shopify.locale) {
     const locale = window.Shopify.locale;
    if (locale !== 'uk' && locale !== 'ru' && locale !== 'en') {
     }
  }

   if (!rootPath.endsWith('/')) rootPath += '/';
 
  const res = await fetch(`${rootPath}products/${handle}.js`);
  
  if (!res.ok) {
    console.error('QuickBuy error: Product not found at', `${rootPath}products/${handle}.js`);
    throw new Error('Product not found');
  }
  
  return res.json();
}

  // ─── Render options ──────────────────────────────────────────────────────────

  function renderOptions() {
    optionsEl.innerHTML = '';

    productData.options.forEach((optionName, optionIndex) => {
      // All possible values for this option
      const values = [...new Set(productData.variants.map(v => v.options[optionIndex]))];

      const group = document.createElement('div');
      group.className = 'qb-option-group';

      const labelEl = document.createElement('p');
      labelEl.className = 'qb-option-label';
      const optionNameStr = optionName && typeof optionName === 'object'
        ? (optionName.name || optionName.value || ('Option ' + (optionIndex + 1)))
        : String(optionName || '');
      const selectedVal = selectedOptions[optionIndex] || '';
      labelEl.innerHTML = optionNameStr + ': <span class="qb-option-selected-value">' + selectedVal + '</span>';

      const pills = document.createElement('div');
      pills.className = 'qb-option-pills';

      values.forEach(value => {
        // Is this value available given the other currently-selected options?
        const testOptions = [...selectedOptions];
        testOptions[optionIndex] = value;
        const matchingVariant = productData.variants.find(v =>
          v.options.every((opt, i) => opt === testOptions[i])
        );
        const isAvailable = matchingVariant ? matchingVariant.available : false;
        const isSelected  = selectedOptions[optionIndex] === value;

        const pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'qb-pill' +
          (isSelected   ? ' is-selected'   : '') +
          (!isAvailable ? ' is-unavailable' : '');
        pill.textContent = value;
        pill.dataset.optionIndex = optionIndex;
        pill.dataset.value = value;
        if (!isAvailable) pill.disabled = true;

        pill.addEventListener('click', () => {
          selectedOptions[optionIndex] = value;
          renderOptions();
          updateSubmitState();
        });

        pills.appendChild(pill);
      });

      group.appendChild(labelEl);
      group.appendChild(pills);
      optionsEl.appendChild(group);
    });
  }

  function updateSubmitState() {
  const variant = findVariant();
  variantInp.value = variant ? variant.id : '';

  // Обновляем цену выбранного варианта
  if (variant && priceEl) {
    priceEl.textContent = formatMoney(variant.price);
  }

  if (!variant) {
    unavailMsg.style.display = 'block';
    submitBtn.disabled = true;
  } else if (!variant.available) {
    unavailMsg.style.display = 'block';
    submitBtn.disabled = true;
  } else {
    unavailMsg.style.display = 'none';
    submitBtn.disabled = false;
  }

  setSubmitText('default');
}

  // ─── Init drawer with product ─────────────────────────────────────────────

  async function initDrawer(handle, triggerVariantId, parentId = null) {
  parentProductId = parentId;
    // Set header info immediately if available from card data
    // (will be updated after fetch)

    showLoading();
    openDrawer();

    try {
      productData = await loadProduct(handle);

      // Header
      titleEl.textContent  = productData.title;
      const firstVariant = productData.variants.find(v => v.available) || productData.variants[0];
      priceEl.textContent = firstVariant.price_with_currency || formatMoney(productData.price_min);
      imageEl.src = productData.featured_image
        ? productData.featured_image.replace(/(\.\w+)$/, '_56x56_crop_center$1')
        : '';
      imageEl.alt = productData.title;

      // Pre-select: try to match the variant that was on the card
      const triggerVariant = productData.variants.find(v => v.id == triggerVariantId);
      if (triggerVariant) {
        selectedOptions = [...triggerVariant.options];
      } else {
        // Select first available variant
        const firstAvail = productData.variants.find(v => v.available) || productData.variants[0];
        selectedOptions = [...firstAvail.options];
      }

      renderOptions();
      updateSubmitState();
      showContent();

    } catch (err) {
      console.error('[QuickBuy] Failed to load product:', err);
      closeDrawer();
    }
  }

  // ─── Submit ──────────────────────────────────────────────────────────────────

  function setSubmitText(state) {
    const map = {
      default : submitBtn.dataset.textDefault,
      loading : submitBtn.dataset.textLoading,
      added   : submitBtn.dataset.textAdded,
      error   : submitBtn.dataset.textError,
    };
    submitBtn.textContent = map[state] || map.default;
  }

  document.getElementById('qb-form').addEventListener('submit', async e => {
    e.preventDefault();

    const variantId = variantInp.value;
    if (!variantId) return;

    submitBtn.disabled = true;
    submitBtn.classList.remove('is-added', 'is-error');
    setSubmitText('loading');

    try {
      const cartItem = {
  id: parseInt(variantId, 10),
  quantity: 1
};

if (
  productData?.handle === 'service-adaptis-amulet-starlink' &&
  parentProductId
) {
  cartItem.properties = {
    _bundle_parent: String(parentProductId)
  };
}

const res = await fetch('/cart/add.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(cartItem),
});

      if (!res.ok) throw new Error('Cart error');

      setSubmitText('added');
      submitBtn.classList.add('is-added');

      // Update cart count in header (works with most Shopify themes)
      updateCartCount();

      // Close drawer after short delay
      setTimeout(() => {
        closeDrawer();
      }, 1400);

    } catch (err) {
      console.error('[QuickBuy] Add to cart failed:', err);
      setSubmitText('error');
      submitBtn.classList.add('is-error');
      submitBtn.disabled = false;
      setTimeout(() => {
        submitBtn.classList.remove('is-error');
        setSubmitText('default');
      }, 2500);
    }
  });

  // ─── Update cart count bubble ─────────────────────────────────────────────

  async function updateCartCount() {
    try {
      const res  = await fetch(`/cart.js?t=${Date.now()}`, { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
      const cart = await res.json();

      document.querySelectorAll('[data-testid="cart-bubble"], .cart-bubble__text-count, [ref="cartBubbleCount"]').forEach(el => {
        el.textContent = cart.item_count;
        el.classList.remove('hidden', 'visually-hidden');
      });

      const cartBubble = document.querySelector('.cart-bubble');
      if (cartBubble) {
        cartBubble.removeAttribute('hidden');
        cartBubble.classList.remove('visually-hidden');
        cartBubble.style.display = '';
      }

      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    } catch (e) {
      // non-critical
    }
  }

  // ─── Quick-add directly (no variants needed) ──────────────────────────────

  async function quickAddDirect(variantId, btn) {
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.dataset.textLoading || ' ';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
      });

      if (!res.ok) throw new Error('Cart error');

      btn.textContent = btn.dataset.textAdded || ' ';
      updateCartCount();

      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2000);

    } catch (e) {
      btn.textContent = btn.dataset.textError || ' ';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2000);
    }
  }

  // ─── Hook into product cards ──────────────────────────────────────────────
  // Uses data-qb-trigger on <button type="button"> — no <form>, no submit conflict

  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-qb-trigger]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const handle      = btn.dataset.handle;
    const variantId   = btn.dataset.variant;
    const hasVariants = btn.dataset.hasVariants === 'true';

    if (!variantId) return;

    if (hasVariants && handle) {
      initDrawer(handle, variantId);
    } else {
      quickAddDirect(variantId, btn);
    }
  }, true); // useCapture — спрацьовує до будь-якого stopPropagation

  // ─── Public API (optional) ───────────────────────────────────────────────
  window.AdaptisQuickBuy = { open: initDrawer, close: closeDrawer };

})();